
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/awards",
      function () {
        return require("private-next-pages/awards/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/awards"])
      });
    }
  